import React from "react";
import {
  Box
} from "@mui/material";
import {
  AppBar as AppBarComponent,
  SideBar as SideBarComponent
} from "./components";
import {useLocation, useNavigate, useParams} from "react-router-dom";

const SIDE_BAR_WIDTH = 224;

const menuSideBar = [
  {label: 'Материалы', path: '/materials', Icon: require('../../assets/svg/sidebar/materials.svg').default},
  {label: 'Комплексы', path: '/complex', Icon: require('../../assets/svg/sidebar/complexes.svg').default},
  {label: 'Адреса', path: '/addresses', Icon: require('../../assets/svg/sidebar/addresses.svg').default},
  {label: 'Скрытые ГРЗ', path: '/hidden-grz', Icon: require('../../assets/svg/sidebar/hidden-grz.svg').default},
  {label: 'Отчеты', path: '/reports', Icon: require('../../assets/svg/sidebar/reports.svg').default},
  {label: 'Документы', path: '/documents', Icon: require('../../assets/svg/sidebar/documents.svg').default},
  {
    label: 'Задания',
    path: '/tasks',
    Icon: require('../../assets/svg/sidebar/tasks.svg').default,
    IconActive: require('../../assets/svg/sidebar/tasks-active.svg').default,
  },
]

export const RouterContext = React.createContext({});
const CabinetLayout = ({ title, children, ...otherProps }) => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Box sx={{display: "flex"}}>
      <AppBarComponent title={title} sideBarWidth={SIDE_BAR_WIDTH} />
      <SideBarComponent sideBarWidth={SIDE_BAR_WIDTH} menu={menuSideBar} />
      <Box component="main" sx={{ flexGrow: 1, pt: "100px", pl: "32px", pr: "32px", pb: "20px", backgroundColor: "#FFFFFF" }}>
        <RouterContext.Provider value={{location, navigate, params}}>
          {children}
        </RouterContext.Provider>
      </Box>
    </Box>
  )
}

export default CabinetLayout
